import React from "react";
import { OfflineModeAssignment } from "types";
import { useDispatch } from "hooks";
import { Button, Icon, Typography } from "components";
import { removeCachedAssignment } from "components/offline-tools/duck/operations";
import styles from "./Assessment.module.css";

interface AssessmentProps {
  data: OfflineModeAssignment;
}

const Assessment: React.FC<AssessmentProps> = ({ data }) => {
  const dispatch = useDispatch();

  const deleteHandler = (): void => {
    if (!localStorage.getItem("hasDeletedAssignmentsFromCache")) {
      localStorage.setItem("hasDeletedAssignmentsFromCache", "true");
    }
    removeCachedAssignment(data, dispatch);
  };

  return (
    <Typography variant="c2" component="li" className={styles.wrapper}>
      {data.title}
      <Button
        iconOnly
        prefix={<Icon name="delete-outlined" size="small" />}
        size="small"
        className={styles.delete}
        variant="clear"
        shape="rounded"
        onClick={deleteHandler}
      />
    </Typography>
  );
};

export default Assessment;
